enum MailSource {
    Inbox = "inbox",
    Archive = "archive",
    SentItems = "sentitems",
    Drafts = "drafts",
    Deleteditems = "deleteditems",
    JunkEmail = "junkemail",
}

export default MailSource;
